import styled from 'styled-components';
import Toggler from '@minecraft.toggler';
import FormikSelect from '@minecraft.formik-select';

export const FilterTitle = styled.div`
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 1rem;
`;

export const Delimiter = styled.div`
  background-color: ${(props): string => props.theme.colors.primary.ltGrey1};
  margin: 2rem 0;
  height: 0.0625rem;
  width: 100%;
`;

export const StyledToggler = styled(Toggler)`
  ${Toggler.StyledTogglerContainer} {
    padding: 0.5rem 0;
  }

  ${Toggler.StyledTogglerItem} {
    svg {
      height: 1rem;
      width: 1rem;
    }
  }

  ${Toggler.StyledCollapse} {
    margin: 0;
  }

  &:not(:first-child) {
    ${Toggler.StyledTogglerContainer} {
      padding-top: 1rem;
    }
  }
`;

export const StyledFormikSelect = styled(FormikSelect)`
  min-width: 6.25rem;
`;
